
import {
  Component, Prop, Watch, Vue, Ref,
} from 'vue-property-decorator'
import Inventory from '@/models/Inventory'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import CompanyPicker from '@/components/CompanyPicker/CompanyPicker.vue'
import ViewModel from '@/models/ViewModel'
import FormInput from '@/components/FormInput/FormInput.vue'
import Creative from '@/models/Creative'
import SelectOption from '@/models/interface/SelectOption'
import PublisherPicker from '@/components/PublisherPicker/PublisherPicker.vue'
import { percentageMask, currencyMask } from '@/models/interface/Masks'
import IconAction from '@/components/IconAction/IconAction.vue'
import SpecialFeaturesPicker from '@/components/MediaPlanBuilder/SpecialFeaturesPicker.vue'
// @ts-ignore
import { VueMaskDirective } from 'v-mask'
import { clone, result } from 'lodash'
import FooterNav from '@/components/FooterNav/FooterNav.vue'
import CheckboxInput from '@/components/CheckboxInput/index.vue'
import {
  AdserverTypes,
  SchedulerModes,
  RevenueModes,
  RemoteConnections,
  CategoryAuthorityOptions,
  CategoryAuthorityVersionOptions,
} from '@/models/interface/Common'
import AdunitPicker from '@/components/AdunitPicker/AdunitPicker.vue'
import EventTracker from '@/components/EventTracker/EventTracker.vue'
import Company from '@/models/Company'
import dmaCodes from '@/data/dma_options'
import stateOptions from '@/data/state_options'
import Api from '@/models/Api'
import WebMessage from '@/models/WebMessage'
import object_maps from '../object_maps'

Vue.directive('mask', VueMaskDirective)
@Component({
  components: {
    CompanyPicker,
    SelectPicker,
    FormInput,
    PublisherPicker,
    SpecialFeaturesPicker,
    IconAction,
    FooterNav,
    CheckboxInput,
    AdunitPicker,
    EventTracker,
  },
})
export default class InventoryForm extends ViewModel {
  @Ref() createTable!: any

  @Ref() readonly eventTracker!: EventTracker

  @Prop()
  public id!: string

  @Prop({ default: false })
  public disabled!: boolean

  @Prop({ default: false })
  public hideFooter!: boolean

  @Prop({ default: false })
  public isLoading!: boolean

  @Prop()
  public adunit!: any

  public view_mode!: string

  public show_sidebar!: boolean

  public modal: any = {
    empty: false,
    remote: false,
  }

  public remote_copy = {
    status: 'init',
    line_item_id: '',
    fields_to_push: [] as string[],
    result: [] as any,
  }

  public inventory: Inventory = new Inventory()

  public loading: boolean = false

  public adding_special_rates: boolean = false

  public editing_special_rates: boolean = false

  public temp_special_rate_index: any = 0

  public busy = true

  public remote_inventories: any = []

  public remote_contents: any = []

  public source_split: any = []

  public remote_packages: any = []

  public remote_content_package_ids: any = []

  public remote_supply_inventory_order_split: any = []

  public remote_supply_package_split: any = []

  public remote_labels: any = []

  public temp_inventory_special_rate: any = {
    type: null,
    model: 'surcharge',
    value: 0,
    priority: 1,
  }

  public inventory_map_fields = [
    {
      key: 'code',
      label: 'External Client Code',
      sortable: true,
      show: false,
      tdClass: 'align-middle text-center',
      thStyle: { width: '40%' },
      thClass: 'text-center',
    },
    {
      key: 'target',
      label: 'Target',
      sortable: true,
      show: false,
      tdClass: 'align-middle text-center',
      thClass: 'text-center',
    },
    {
      key: 'actions',
      label: ' ',
      class: 'text-center align-middle text-capitalize',
      show: true,
      thStyle: { width: '100px' },
      thClass: 'align-middle text-center',
    },
  ]

  public special_rates_fields: any = [
    {
      key: 'type',
      label: 'Type',
      sortable: true,
      show: false,
      tdClass: 'align-middle text-center',
      thClass: 'text-center',
    },
    {
      key: 'model',
      label: 'Model',
      sortable: true,
      show: false,
      tdClass: 'align-middle text-center',
      thClass: 'text-center',
    },
    {
      key: 'value',
      label: 'Value',
      sortable: true,
      show: false,
      tdClass: 'align-middle text-center',
      thClass: 'text-center',
    },
    {
      key: 'priority',
      label: 'Priority',
      sortable: true,
      show: false,
      tdClass: 'align-middle text-center',
      thClass: 'text-center',
    },
    {
      key: 'action',
      label: 'Actions',
      sortable: true,
      show: false,
      tdClass: 'align-middle text-center',
      thClass: 'text-center',
    },
  ]

  @Watch('isLoading')
  public isLoadingOnChange(val) {
    this.loading = val
  }

  public startRemoteCopy() {
    if (!this.inventory.remote_connection) {
      WebMessage.error('Please select remote connection first')
      return
    }
    this.remote_copy.fields_to_push = []
    this.remote_copy.status = 'init'
    this.modal.remote = true
  }

  public fetchRemoteData() {
    if (!this.remote_copy.line_item_id) {
      WebMessage.error('Please provide Line Item / Placement ID')
      return
    }
    this.remote_copy.status = 'loading'

    const api = new Api()

    api
      .post('inventory/get-remote-settings', {
        remote_connection: this.inventory.remote_connection,
        line_item_id: this.remote_copy.line_item_id,
      })
      .then((response: any) => {
        if (
          response.status === 200
          && response.data.result.settings
          && Object.keys(response.data.result.settings).length
        ) {
          this.remote_copy.result = response.data.result.settings
          this.remote_copy.status = 'review'
        } else {
          WebMessage.error(
            'No data found for the provided Line Item / Placement ID, please review the connection and ID.',
          )
          this.remote_copy.status = 'init'
        }
      })
      .catch(() => {
        this.remote_copy.status = 'init'
      })
  }

  public applyRemoteData() {
    if (!this.remote_copy.fields_to_push.length) {
      WebMessage.error('Please select at least one field to copy from remote')
      return
    }

    if (this.remote_copy.fields_to_push.includes('advertiser_id')) {
      this.inventory.remote_data.remote_advertiser_id = this.remote_copy.result.advertiser_id
    }

    if (this.remote_copy.fields_to_push.includes('inventory_ids')) {
      this.remote_copy.result.inventory_ids.forEach((inventory: any) => {
        this.addRemoteTag(inventory)
      })
      this.inventory.remote_data.remote_inventory_ids = this.remote_copy.result.inventory_ids
    }

    if (this.remote_copy.fields_to_push.includes('content_ids')) {
      this.remote_copy.result.remote_content_ids.forEach((content: any) => {
        this.addRemoteContent(content)
      })

      this.inventory.remote_data.remote_content_ids = this.remote_copy.result.content_ids
    }

    if (this.remote_copy.fields_to_push.includes('labels')) {
      this.remote_copy.result.labels.forEach((label: any) => {
        this.addRemoteLabel(label)
      })

      this.inventory.remote_data.remote_label_ids = this.remote_copy.result.labels
    }

    if (this.remote_copy.fields_to_push.includes('supply_source_split')) {
      this.remote_copy.result.supply_source_split.forEach((source: any) => {
        this.addSupplySourceSplit(source)
      })

      this.inventory.remote_data.supply_source_split = this.remote_copy.result.supply_source_split
    }

    if (this.remote_copy.fields_to_push.includes('packages')) {
      this.remote_copy.result.packages.forEach((pkg: any) => {
        this.addRemotePackage(pkg)
      })

      this.inventory.remote_data.remote_package_ids = this.remote_copy.result.packages
    }

    if (this.remote_copy.fields_to_push.includes('content_package_ids')) {
      this.remote_copy.result.content_package_ids.forEach((pkg: any) => {
        this.addRemoteContentPackage(pkg)
      })

      this.inventory.remote_data.remote_content_package_ids = this.remote_copy.result.content_package_ids
    }

    if (this.remote_copy.fields_to_push.includes('supply_inventory_order_split')) {
      this.remote_copy.result.supply_inventory_order_split.forEach((pkg: any) => {
        this.addRemoteSupplyInventoryOrderSplit(pkg)
      })

      this.inventory.remote_data.supply_inventory_order_split = this.remote_copy.result.supply_inventory_order_split
    }

    if (this.remote_copy.fields_to_push.includes('supply_package_split')) {
      this.remote_copy.result.supply_package_split.forEach((pkg: any) => {
        this.addRemoteSupplyPackageSplit(pkg)
      })

      this.inventory.remote_data.supply_package_split = this.remote_copy.result.supply_package_split
    }

    this.modal.remote = false
    WebMessage.success('Remote data applied successfully')
  }

  public get macros() {
    return this.eventTracker?.macros
  }

  public get schduler_modes() {
    return SchedulerModes
  }

  public get revenue_modes() {
    return RevenueModes
  }

  public get remote_connections() {
    return RemoteConnections
  }

  public get authority_options() {
    return CategoryAuthorityOptions
  }

  public get authority_version_options() {
    if (!CategoryAuthorityVersionOptions[this.inventory.category_authority]) {
      return []
    }
    return CategoryAuthorityVersionOptions[this.inventory.category_authority]
  }

  public product_options = [
    {
      value: 'ssl',
      name: 'SSL',
    },
    {
      value: 'home',
      name: 'Home',
    },
  ]

  public status_options = [
    {
      value: true,
      name: 'Active',
    },
    {
      value: false,
      name: 'Inactive',
    },
  ]

  public apply_to_children_rate = [
    {
      value: true,
      name: 'On',
    },
    {
      value: false,
      name: 'Off',
    },
  ]

  public bool_options = [
    {
      value: false,
      name: 'Yes',
    },
    {
      value: true,
      name: 'No',
    },
  ]

  public model_options = [
    {
      value: 'surcharge',
      name: 'Surcharge',
    },
    {
      value: 'base',
      name: 'Base',
    },
    {
      value: 'absolute',
      name: 'Absolute',
    },
  ]

  public get features_options(): any {
    return object_maps.features_options
  }

  public get device_options() {
    return Inventory.module.device_options
  }

  // The 15s ladder ad units are marked against, mirroring Inventory::CREATIVE_LENGTHS.
  public get creative_length_options() {
    const options: SelectOption[] = []
    for (let seconds = 15; seconds <= 300; seconds += 15) {
      options.push(new SelectOption(`${seconds}s`, seconds))
    }
    return options
  }

  public double_verify_options = [
    new SelectOption('Yes', 'yes'),
    new SelectOption('No', 'no'),
    new SelectOption('DV only', 'dv_only'),
  ]

  public get adserver_options() {
    return AdserverTypes
  }

  public get inventory_options() {
    return Inventory.module.type_options
  }

  public get publisher_options() {
    return Inventory.module.publisher_options
  }

  public get live_options() {
    return Inventory.module.live_options
  }

  public get dma_options() {
    return dmaCodes
  }

  public get state_options() {
    return stateOptions
  }

  public get creative_type_options() {
    const options = Creative.module.type_options.map(a => ({ ...a }))
    options.unshift(new SelectOption('Any', null))
    return options
  }

  public addTag(newTag: string) {
    this.report_name_options.push(new SelectOption(newTag, newTag))
    this.inventory.publisher_name = newTag
  }

  // Allow ad-hoc creation of new group names directly from the picker. The
  // canonical option list is the union across all inventories (loaded once).
  public addInventoryGroupTag(newTag: string) {
    this.inventory_group_options.push(new SelectOption(newTag, newTag))
    if (!Array.isArray(this.inventory.inventory_groups)) {
      this.inventory.inventory_groups = []
    }
    if (!this.inventory.inventory_groups.includes(newTag)) {
      this.inventory.inventory_groups.push(newTag)
    }
  }

  // Mirror addTag: register the typed value as an option and select it. The
  // option list is the distinct set of existing codes across inventories.
  public addPublisherInternalCodeTag(newTag: string) {
    this.publisher_internal_code_options.push(new SelectOption(newTag, newTag))
    this.inventory.publisher_internal_code = newTag
  }

  public report_name_options: SelectOption[] = []

  public inventory_group_options: SelectOption[] = []

  public publisher_internal_code_options: SelectOption[] = []

  @Watch('inventory.publisher_id')
  public updatePublisher(val) {
    if (val && this.inventory.rate == 0) {
      Company.find(val).then((o: Company) => {
        if (this.inventory.rate == 0) {
          this.inventory.rate = o.rate
        }
      })
    }
  }

  @Watch('inventory.parent_id')
  public updateParent(val) {
    if (val && !this.inventory.publisher_name) {
      Inventory.get(val).then((o: Inventory) => {
        if (!this.inventory.publisher_name && o.publisher_name) {
          this.inventory.publisher_name = o.publisher_name
        }
      })
    }
  }

  public get masks() {
    return {
      currencyMask,
      percentageMask,
    }
  }

  public addSpecialRate() {
    let tmp = clone(this.temp_inventory_special_rate)
    tmp.value = parseFloat(tmp.value.replaceAll('$', ''))
    const obj = JSON.parse(JSON.stringify(tmp))

    if (this.editing_special_rates) {
      Vue.set(this.inventory.special_rates, this.temp_special_rate_index, obj)
      // this.inventory.special_rates[this.temp_special_rate_index] = obj
      this.editing_special_rates = false
      this.temp_special_rate_index = 0
    } else {
      this.inventory.special_rates.push(obj)
    }

    setTimeout(() => {
      this.resetTempSpecialRate(true)
    }, 200)
  }

  public resetTempSpecialRate(cancel = false) {
    this.temp_inventory_special_rate = {
      type: null,
      model: 'surcharge',
      value: 0,
      priority: 1,
    }
    this.editing_special_rates = false
    if (cancel) {
      this.adding_special_rates = false
    }
  }

  public editSpecialRate(target: any) {
    let index = this.inventory.special_rates.findIndex(
      (i: any) =>
        i.type === target.type
        && i.model === target.model
        && i.value === target.value
        && i.priority === target.priority,
    )
    this.temp_special_rate_index = index
    this.editing_special_rates = true
    this.temp_inventory_special_rate = { ...clone(this.inventory.special_rates[index]) }
    this.adding_special_rates = true
  }

  public removeSpecialRate(target: any) {
    let index = this.inventory.special_rates.findIndex(
      (i: any) =>
        i.type === target.type
        && i.model === target.model
        && i.value === target.value
        && i.priority === target.priority,
    )
    this.inventory.special_rates.splice(index, 1)
  }

  public update() {
    this.loading = true
    this.inventory
      .save()
      .then((response: any) => {
        this.loading = false
        if (response.status == 200) {
          this.$router.push({ name: 'Inventories' })
        }
      })
      .catch(() => {
        this.loading = false
      })
  }

  public onSubmit() {
    this.loading = true
    this.update()
  }

  public cancel() {
    this.$router.push({ name: 'Inventories' })
  }

  @Watch('show_sidebar')
  public onSidebarStatus() {
    this.init()
  }

  public init() {
    Inventory.loadInventoryGroupOptions().then((o: any) => {
      this.inventory_group_options = o
    })
    Inventory.loadPublisherInternalCodeOptions().then((o: any) => {
      this.publisher_internal_code_options = o
    })
    Inventory.loadReportNameOptions().then((o: any) => {
      this.report_name_options = o

      if (this.adunit) {
        this.inventory = { ...this.adunit }
        this.busy = false
        return
      }

      if (this.id) {
        this.busy = true
        Inventory.get(this.id).then(o => {
          if (o instanceof Inventory) {
            this.inventory = o

            this.remote_inventories = this.inventory.remote_data.remote_inventory_ids.map(
              (o: string) => new SelectOption(o, o),
            )

            this.remote_labels = this.inventory.remote_data.remote_label_ids.map(
              (o: string) => new SelectOption(o, o),
            )

            this.remote_contents = this.inventory.remote_data.remote_content_ids.map(
              (o: string) => new SelectOption(o, o),
            )

            this.source_split = this.inventory.remote_data.supply_source_split.map(
              (o: string) => new SelectOption(o, o),
            )

            this.remote_packages = this.inventory.remote_data.remote_package_ids.map(
              (o: string) => new SelectOption(o, o),
            )
            this.remote_content_package_ids = this.inventory.remote_data.remote_content_package_ids.map(
              (o: string) => new SelectOption(o, o),
            )
            this.remote_supply_inventory_order_split = this.inventory.remote_data.supply_inventory_order_split.map(
              (o: string) => new SelectOption(o, o),
            )
            this.remote_supply_package_split = this.inventory.remote_data.supply_package_split.map(
              (o: string) => new SelectOption(o, o),
            )
          }
          this.busy = false
        })
      } else {
        this.inventory = new Inventory()
        const { query } = this.$route
        if (query.parent_id && typeof query.parent_id === 'string') {
          this.inventory.parent_id = query.parent_id
        }
        this.busy = false
      }
    })
  }

  public addRemoteTag(newTag: string) {
    const tags = newTag
      .split(',')
      .map((o: string) => o.trim())
      .filter((o: string) => o.length > 0)

    tags.forEach((tag: string) => {
      this.remote_inventories.push(new SelectOption(tag, tag))
    })

    setTimeout(() => {
      this.inventory.remote_data.remote_inventory_ids.push(...tags)
    }, 100)
  }

  public addRemoteContent(newTag: string) {
    const tags = newTag
      .split(',')
      .map((o: string) => o.trim())
      .filter((o: string) => o.length > 0)

    tags.forEach((tag: string) => {
      this.remote_contents.push(new SelectOption(tag, tag))
    })

    setTimeout(() => {
      this.inventory.remote_data.remote_content_ids.push(...tags)
    }, 100)
  }

  // addSupplySourceSplit
  public addSupplySourceSplit(newTag: string) {
    const tags = newTag
      .split(',')
      .map((o: string) => o.trim())
      .filter((o: string) => o.length > 0)

    tags.forEach((tag: string) => {
      this.source_split.push(new SelectOption(tag, tag))
    })

    setTimeout(() => {
      this.inventory.remote_data.supply_source_split.push(...tags)
    }, 100)
  }

  public addRemotePackage(newTag: string) {
    const tags = newTag
      .split(',')
      .map((o: string) => o.trim())
      .filter((o: string) => o.length > 0)

    tags.forEach((tag: string) => {
      this.remote_packages.push(new SelectOption(tag, tag))
    })

    setTimeout(() => {
      this.inventory.remote_data.remote_package_ids.push(...tags)
    }, 100)
  }

  public addRemoteContentPackage(newTag: string) {
    const tags = newTag
      .split(',')
      .map((o: string) => o.trim())
      .filter((o: string) => o.length > 0)

    tags.forEach((tag: string) => {
      this.remote_content_package_ids.push(new SelectOption(tag, tag))
    })

    setTimeout(() => {
      this.inventory.remote_data.remote_content_package_ids.push(...tags)
    }, 100)
  }

  public addRemoteSupplyInventoryOrderSplit(newTag: string) {
    const tags = newTag
      .split(',')
      .map((o: string) => o.trim())
      .filter((o: string) => o.length > 0)

    tags.forEach((tag: string) => {
      this.remote_supply_inventory_order_split.push(new SelectOption(tag, tag))
    })

    setTimeout(() => {
      this.inventory.remote_data.supply_inventory_order_split.push(...tags)
    }, 100)
  }

  public addRemoteSupplyPackageSplit(newTag: string) {
    const tags = newTag
      .split(',')
      .map((o: string) => o.trim())
      .filter((o: string) => o.length > 0)

    tags.forEach((tag: string) => {
      this.remote_supply_package_split.push(new SelectOption(tag, tag))
    })

    setTimeout(() => {
      this.inventory.remote_data.supply_package_split.push(...tags)
    }, 100)
  }

  public addRemoteLabel(newTag: string) {
    const tags = newTag
      .split(',')
      .map((o: string) => o.trim())
      .filter((o: string) => o.length > 0)

    tags.forEach((tag: string) => {
      this.remote_labels.push(new SelectOption(tag, tag))
    })

    setTimeout(() => {
      this.inventory.remote_data.remote_label_ids.push(...tags)
    }, 100)
  }

  public mounted() {
    this.init()
  }
}
